import { render } from "./ListScheduleClient.vue?vue&type=template&id=95dd5a86&ts=true"
import script from "./ListScheduleClient.vue?vue&type=script&lang=ts"
export * from "./ListScheduleClient.vue?vue&type=script&lang=ts"

import "./clientSchedule.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__